import type { FlashcardsFeRouterCtx } from '../router/flashcards-fe.router-ctx'

/** page-views.spec.md: the client skips a call it already sent for the same page within 10 minutes; the server enforces the same window. */
export const pageViewSkipMs = 10 * 60_000

// One clock per signed-in client, keyed by its rpc client so two users mounted in one process never share it.
const lastSentAt = new WeakMap<object, Map<string, number>>()

/** Records that the signed-in member opened a page. Views are online-only: a failure is reported to tel and dropped (page-views.decisions.md). */
export function recordPageView(ctx: Pick<FlashcardsFeRouterCtx, 'rpcClient' | 'tel'>, workspaceId: string, pageId: string): void {
  let sent = lastSentAt.get(ctx.rpcClient)
  if (!sent) { sent = new Map(); lastSentAt.set(ctx.rpcClient, sent) }
  const key = `${workspaceId}/${pageId}`
  const now = Date.now()
  const previous = sent.get(key)
  if (previous !== undefined && now - previous < pageViewSkipMs) return
  sent.set(key, now)
  void ctx.tel.span({ name: 'page.view.record', target: 'job', input: { workspaceId, pageId } }, async tel => {
    try {
      await ctx.rpcClient.page.recordView.mutate({ workspaceId, pageId }, { tel })
    } catch (error) {
      tel.warn('page view not recorded', { operation: 'page.view.record', error: error instanceof Error ? error.message : String(error) })
    }
  })
}
